import { render, staticRenderFns } from "./ProfitExtract.vue?vue&type=template&id=5e96e745&scoped=true&"
import script from "./ProfitExtract.vue?vue&type=script&lang=js&"
export * from "./ProfitExtract.vue?vue&type=script&lang=js&"
import style0 from "./ProfitExtract.vue?vue&type=style&index=0&id=5e96e745&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e96e745",
  null
  
)

export default component.exports